import React from "react";
import { Account } from "@/types/account-mapping-api";
import { Checkbox } from "@mui/material";

interface AccountCardProps {
  account: Account;
  isSelected?: boolean;
  onSelectToggle?: (accountNumber: string, isSelected: boolean) => void;
}

const AccountCard: React.FC<AccountCardProps> = ({ 
  account,
  isSelected = false,
  onSelectToggle
}) => {
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onSelectToggle) {
      onSelectToggle(account.number, e.target.checked);
      e.stopPropagation();
    }
  };

  return (
    <div 
      className="flex items-center px-2 py-1 bg-white rounded-md border"
      data-account-number={account.number}
    >
      {onSelectToggle && (
        <Checkbox 
          checked={isSelected} 
          onChange={handleCheckboxChange}
          onClick={(e) => e.stopPropagation()}
          size="small"
          className="mr-2"
        />
      )}
      <div className="flex flex-col">
        <span className="text-sm font-semibold text-gray-600">{account.mainAccountDescription}</span>
        <div className="flex items-center">
          <span className="text-sm font-semibold">{account.number}</span>
          <span className="ml-2 text-sm">{account.description}</span>
        </div>
      </div>
      
    </div>
  );
};

export default AccountCard;
